var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"index-home-sys",attrs:{"id":"containt"}},[_c('i',{staticClass:"iconfont icon-a-kaifa1"}),_c('span',[_vm._v(_vm._s(_vm.$t1('开发管理平台')))])])}
var staticRenderFns = []

export { render, staticRenderFns }